<template>
  <div
    class="drop-zone"
    :class="{ 'drag-over': isDragOver }"
    @dragenter.prevent="isDragOver = true"
    @dragover.prevent
    @dragleave.prevent="onDragLeave"
    @drop.prevent="handleDrop"
  >
    <b-row class="h-100" align-v="center" style="min-height: 200px;">
      <b-col cols="12" class="text-center">
        <div v-if="!archivo">
          <img alt="upload" width="60px" :src="require('@/assets/icons/excel_verde.svg')">
          <p class="mt-3 mb-2 texto-dropzone">Arrastra tu archivo aquí o</p>
          <b-form-file
            v-model="archivoLocal"
            accept=".csv, .xls, .xlsx"
            placeholder="Selecciona un archivo"
            browse-text="Buscar"
            class="mx-auto"
            style="max-width: 400px;"
          ></b-form-file>
          <p class="mt-2 texto-allowed">Archivos permitidos: .csv, .xls, .xlsx</p>
        </div>
        <div v-else>
          <img alt="file" width="60px" :src="require('@/assets/icons/excel_verde.svg')">
          <p class="mt-3 texto-dropzone">Archivo cargado:</p>
          <p class="texto-archivo"><strong>{{ archivo.name }}</strong></p>
          <p class="texto-tamaño">{{ (archivo.size / 1024).toFixed(2) }} KB</p>
          <b-button variant="outline-danger" size="sm" @click="eliminarArchivo" class="mt-2">
            Eliminar archivo
          </b-button>
        </div>
      </b-col>
    </b-row>
  </div>
</template>

<script>
export default {
  name: 'ZonaCargaArchivo',
  props: {
    archivo: {
      type: File,
      default: null
    }
  },
  data() {
    return {
      isDragOver: false,
      archivoLocal: null
    }
  },
  watch: {
    archivoLocal(newVal) {
      this.$emit('update:archivo', newVal);
    }
  },
  methods: {
    onDragLeave(event) {
      if (event.target.classList.contains('drop-zone')) {
        this.isDragOver = false;
      }
    },
    handleDrop(event) {
      this.isDragOver = false;
      const files = event.dataTransfer.files;
      if (files.length > 0) {
        const file = files[0];
        const validExtensions = ['.csv', '.xls', '.xlsx'];
        const fileExtension = '.' + file.name.split('.').pop().toLowerCase();
        if (validExtensions.includes(fileExtension)) {
          this.$emit('update:archivo', file);
        } else {
          this.$swal.fire({
            icon: 'error',
            title: 'Archivo no válido',
            text: 'Solo se permiten archivos .csv, .xls o .xlsx',
            confirmButtonColor: '#1B81AF'
          });
        }
      }
    },
    eliminarArchivo() {
      this.archivoLocal = null;
      this.$emit('update:archivo', null);
    }
  }
}
</script>

<style scoped>
.drop-zone {
  border: 2px dashed #ccc;
  border-radius: 8px;
  padding: 2rem;
  background-color: #f8f9fa;
  transition: all 0.3s ease;
}

.drop-zone.drag-over {
  border-color: #1B81AF;
  background-color: #e3f2fd;
}

.texto-dropzone {
  color: #666;
  font-size: 14px;
}

.texto-allowed {
  color: #999;
  font-size: 12px;
}

.texto-archivo {
  color: #333;
  font-size: 14px;
  margin-top: 10px;
}

.texto-tamaño {
  color: #666;
  font-size: 12px;
}
</style>